/**
 * Multi-Print PDP — multi-print-pdp.js
 *   1. Category tab filtering (show/hide swatches)
 *   2. Size button -> variant selection
 *   3. Mobile sticky ATC -> submit main form
 */

(function () {
  'use strict';

  const section = document.querySelector('.multi-print-pdp');
  if (!section) return;

  // Size is remembered per browsing session, not per product.
  var SIZE_KEY = 'mp_pdp_selected_size';
  // Active category tab, remembered across page loads.
  var CAT_KEY = 'mp_pdp_active_category';

  /* Scroll position is restored by the inline script in the section, which
     runs before first paint. Here we only record it on the way out. */
  var SCROLL_KEY = 'mp_pdp_scroll_y';

  /* ---------- 0b. FLAG SWATCH AND STYLE CLICKS ---------- */

  section.querySelectorAll('.print-swatch, .multi-print-pdp__style-btn').forEach(function (link) {
    link.addEventListener('click', function () {
      try { sessionStorage.setItem(SCROLL_KEY, String(window.pageYOffset)); } catch (e) {}
    });
  });

  /* ---------- 1. CATEGORY TAB FILTERING ---------- */

  const tabs = section.querySelectorAll('.multi-print-pdp__tab');
  const swatches = section.querySelectorAll('.print-swatch');

  /* No "All" tab. Nothing selected means everything shows; tapping the
     active tab again clears the filter. category === null is the all state. */

  function applyCategory(category, resetScroll) {
    // Ignore a saved category this product doesn't have.
    if (category) {
      var exists = false;
      tabs.forEach(function (t) {
        if (t.dataset.category === category) exists = true;
      });
      if (!exists) category = null;
    }

    tabs.forEach(function (t) {
      var isActive = category !== null && t.dataset.category === category;
      t.classList.toggle('multi-print-pdp__tab--active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    swatches.forEach(function (swatch) {
      // A swatch can belong to several categories, e.g. "geometric best-sellers"
      var cats = (swatch.dataset.printCategories || '').split(/\s+/).filter(Boolean);
      var show = category === null || cats.indexOf(category) !== -1;
      swatch.setAttribute('data-hidden', show ? 'false' : 'true');
      swatch.style.display = show ? '' : 'none';
    });

    // the pre-paint rule has done its job — inline styles control this now
    var pre = document.getElementById('mp-pdp-precat');
    if (pre) pre.remove();

    if (resetScroll) {
      var container = section.querySelector('.multi-print-pdp__swatch-container');
      if (container) container.scrollLeft = 0;
    }
    return category;
  }

  var activeCategory = null;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = tab.dataset.category;
      // "All" clears the filter; tapping the active tab also clears it
      var next = (cat === 'all' || activeCategory === cat) ? null : cat;
      activeCategory = applyCategory(next, true);
      try {
        if (activeCategory) sessionStorage.setItem(CAT_KEY, activeCategory);
        else sessionStorage.setItem(CAT_KEY, 'all');
      } catch (e) {}
    });
  });

  /* Opening state: whatever was chosen earlier this session, otherwise the
     section's default — Best Sellers when this print is one, All when it is
     not, so her own print is always on screen. */
  (function () {
    var saved = null;
    try { saved = sessionStorage.getItem(CAT_KEY); } catch (e) {}

    var start = saved;
    var printsEl = section.querySelector('.multi-print-pdp__prints');
    if (start === null) start = (printsEl && printsEl.dataset.defaultCategory) || 'all';

    if (start && start !== 'all') {
      activeCategory = applyCategory(start, false);
      // the saved tab may not exist on this product — fall back to all
      if (!activeCategory) activeCategory = applyCategory(null, false);
    } else {
      activeCategory = applyCategory(null, false);
    }

    // mark the tab that matches the state we ended up in
    tabs.forEach(function (t) {
      var on = activeCategory ? t.dataset.category === activeCategory
                              : t.dataset.category === 'all';
      t.classList.toggle('multi-print-pdp__tab--active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  })();

  /* ---------- 1a. GALLERY: thumbnails + hover preview ----------
     Desktop shows one stage image at a time, so hovering a swatch can
     preview that print on the stage without contradicting the rest of the
     gallery. Touch devices are unaffected. */

  var stage   = section.querySelector('.multi-print-pdp__stage');
  var slides  = stage ? stage.querySelectorAll('.multi-print-pdp__gallery-item') : [];
  var thumbs  = section.querySelectorAll('.multi-print-pdp__thumb');
  var heroImg = section.querySelector('.multi-print-pdp__hero-image');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function showSlide(i) {
    slides.forEach(function (sl) {
      var on = sl.dataset.slide === String(i);
      sl.classList.toggle('is-current', on);
      if (!on) {
        var v = sl.querySelector('video');
        if (v && !v.paused) v.pause();
      }
    });
    thumbs.forEach(function (t) {
      t.classList.toggle('is-current', t.dataset.goto === String(i));
    });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showSlide(t.dataset.goto); });
  });

  if (heroImg && canHover && swatches.length) {
    var originalSrc    = heroImg.getAttribute('src');
    var originalSrcset = heroImg.getAttribute('srcset');
    var hoverTimer = null;
    var revertTimer = null;

    // warm the cache so the first hover does not flash
    swatches.forEach(function (sw) {
      var src = sw.dataset.previewSrc;
      if (src && src !== originalSrc) { var pre = new Image(); pre.src = src; }
    });

    var setHero = function (src) {
      if (heroImg.getAttribute('src') === src) return;
      if (src !== originalSrc) heroImg.removeAttribute('srcset');
      else if (originalSrcset) heroImg.setAttribute('srcset', originalSrcset);
      heroImg.setAttribute('src', src);
      heroImg.classList.toggle('is-previewing', src !== originalSrc);
    };

    swatches.forEach(function (sw) {
      var src = sw.dataset.previewSrc;
      if (!src) return;

      sw.addEventListener('mouseenter', function () {
        clearTimeout(revertTimer);
        clearTimeout(hoverTimer);
        // short delay, otherwise sweeping the grid strobes the stage
        hoverTimer = setTimeout(function () {
          showSlide(0);
          setHero(src);
        }, 150);
      });

      sw.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        revertTimer = setTimeout(function () { setHero(originalSrc); }, 140);
      });
    });
  }

  /* ---------- GALLERY SCROLL ARROW (mobile) ---------- */

  var galleryNext = section.querySelector('.multi-print-pdp__gallery-next');

  if (stage && galleryNext) {
    var syncGallery = function () {
      var overflows = stage.scrollWidth - stage.clientWidth > 8;
      var atEnd = stage.scrollLeft + stage.clientWidth >= stage.scrollWidth - 8;
      galleryNext.hidden = !overflows || atEnd;
    };

    galleryNext.addEventListener('click', function () {
      stage.scrollBy({ left: Math.round(stage.clientWidth * 0.82), behavior: 'smooth' });
    });

    stage.addEventListener('scroll', syncGallery, { passive: true });
    window.addEventListener('resize', syncGallery);
    window.addEventListener('load', syncGallery, { once: true });
    syncGallery();
  }

  /* ---------- 1b. SWATCH SCROLL ARROW ----------
     Shown only when the row overflows; hidden once the end is reached. */

  var swatchWrap = section.querySelector('.multi-print-pdp__swatch-wrap');
  var swatchBox  = section.querySelector('.multi-print-pdp__swatch-container');
  var swatchNext = section.querySelector('.multi-print-pdp__swatch-next');

  if (swatchBox && swatchNext) {
    var syncArrow = function () {
      var overflows = swatchBox.scrollWidth - swatchBox.clientWidth > 8;
      var atEnd = swatchBox.scrollLeft + swatchBox.clientWidth >= swatchBox.scrollWidth - 8;
      swatchNext.hidden = !overflows || atEnd;
    };

    swatchNext.addEventListener('click', function () {
      swatchBox.scrollBy({ left: Math.round(swatchBox.clientWidth * 0.8), behavior: 'smooth' });
    });

    swatchBox.addEventListener('scroll', syncArrow, { passive: true });
    window.addEventListener('resize', syncArrow);
    // re-check after the swatch images have loaded
    window.addEventListener('load', syncArrow, { once: true });
    syncArrow();

    // category filtering changes how many swatches are present
    section.querySelectorAll('.multi-print-pdp__tab').forEach(function (t) {
      t.addEventListener('click', function () { setTimeout(syncArrow, 0); });
    });
  }

  /* ---------- 1c. KEEP REBUY IN PLACE ----------
     Rebuy decides its own placement. Depending on how the widget is
     configured it can inject at the end of <body>, which puts it below the
     footer. If that happens, move it into our container under the buy zone.
     Harmless when Rebuy already renders in the right place. */

  var appSlot = section.querySelector('.multi-print-pdp__app-blocks');

  if (appSlot) {
    // only reclaim the widget this section was configured with — Rebuy may
    // run others on the page (generic recommendations, post-purchase) and
    // those should stay where they are
    var wantedIds = (appSlot.dataset.rebuyWidget || '')
      .split(',')
      .map(function (x) { return x.trim(); })
      .filter(Boolean);

    /* Rebuy's real structure, from the rendered DOM:
         <div data-rebuy-id="279304" data-initialized="true">      <- trigger
           <div id="rebuy-widget-279304" class="rebuy-widget ...">  <- widget
             <div class="rebuy-widget-container ...">
       So the widget always gets the element id  rebuy-widget-{id}.
       Target that directly and move its trigger parent if there is one. */

    var relocate = function () {
      var moved = false;

      wantedIds.forEach(function (id) {
        var widget = document.getElementById('rebuy-widget-' + id);
        if (!widget) return;

        // move the trigger wrapper when present, so Rebuy keeps its context
        var node = widget.closest('[data-rebuy-id="' + id + '"]') || widget;

        if (appSlot.contains(node)) return;
        if (!widget.querySelector('.rebuy-widget-container, .rebuy-product-grid')) return;

        appSlot.appendChild(node);
        moved = true;
      });

      return moved;
    };

    // Rebuy renders asynchronously, so watch for it rather than guessing.
    var stopAt = Date.now() + 12000;
    var mo = new MutationObserver(function () {
      relocate();
      if (Date.now() > stopAt) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', function () {
      relocate();
      setTimeout(relocate, 1200);
      setTimeout(function () { relocate(); mo.disconnect(); }, 6000);
    }, { once: true });
  }

  /* ---------- 1d. SIZE GUIDE ----------
     Sized renders this trigger, confirmed from the DOM:
       <div class="sizechart-container loaded">
         <div class="open-sizechart storefront-sizechart-open ..."
              role="button" aria-label="Open size chart">
     It is a div with role=button, not a <button>, and it can render
     anywhere in the product form. Find it, hide it, and have our link
     next to SIZE click it. */

  var sizeLink = section.querySelector('.multi-print-pdp__size-guide-link');
  var SIZED_TRIGGER = '.open-sizechart, .storefront-sizechart-open';

  if (sizeLink && sizeLink.tagName === 'BUTTON') {
    var wireSizeGuide = function () {
      var trigger = document.querySelector(SIZED_TRIGGER);
      if (!trigger) return false;

      // hide Sized's own button without removing it — the app still needs it
      var wrapper = trigger.closest('.sizechart-container') || trigger;
      wrapper.style.position = 'absolute';
      wrapper.style.width = '1px';
      wrapper.style.height = '1px';
      wrapper.style.margin = '-1px';
      wrapper.style.padding = '0';
      wrapper.style.overflow = 'hidden';
      wrapper.style.clip = 'rect(0 0 0 0)';
      wrapper.style.whiteSpace = 'nowrap';

      sizeLink.addEventListener('click', function (e) {
        e.preventDefault();
        trigger.click();
      });

      return true;
    };

    if (!wireSizeGuide()) {
      // Sized loads asynchronously — watch for the container appearing
      var sizedObserver = new MutationObserver(function () {
        if (wireSizeGuide()) sizedObserver.disconnect();
      });
      sizedObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { sizedObserver.disconnect(); }, 15000);
    }
  }

  /* ---------- 2. SIZE -> VARIANT ---------- */

  const sizeButtons = section.querySelectorAll('.multi-print-pdp__size-btn');
  const variantInput = document.getElementById('multi-print-variant-id');
  const atcButton = section.querySelector('.multi-print-pdp__atc');
  const mainForm = document.getElementById('multi-print-pdp-form');

  sizeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      const variantId = btn.dataset.variantId;

      sizeButtons.forEach(function (b) {
        b.classList.remove('multi-print-pdp__size-btn--active');
      });
      btn.classList.add('multi-print-pdp__size-btn--active');

      if (variantInput) variantInput.value = variantId;

      // Remember the chosen size for the rest of this browsing session, so it
      // carries across page loads when the shopper clicks through prints.
      try {
        sessionStorage.setItem(SIZE_KEY, (btn.textContent || '').trim());
      } catch (e) { /* private mode — not important */ }

      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    });
  });

  /* ---------- 3. MOBILE STICKY ATC ---------- */

  const stickyBtn = document.getElementById('multi-print-sticky-atc');

  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (stickyBtn.disabled) return;

      const activeSize = section.querySelector('.multi-print-pdp__size-btn--active');
      if (!activeSize) {
        const sizeSection = section.querySelector('.multi-print-pdp__sizes');
        if (sizeSection) {
          sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          sizeSection.style.transition = 'background 0.3s ease';
          sizeSection.style.background = '#fff3e0';
          setTimeout(function () {
            sizeSection.style.background = '';
          }, 1500);
        }
        return;
      }

      addToCart(stickyBtn);
    }, true);
  }

  /* ---------- 4. ADD TO CART ----------
     A native form submit navigates to /cart, which bypasses the theme's
     cart drawer. Instead post to Shopify's cart API, then tell the theme
     to refresh. Different themes listen for different things, so we fire
     the common ones and fall back to /cart if none of them respond. */

  /* One timer per button, and the label to restore is captured once — on
     first use — not on every call. Otherwise a second flash captures the
     first flash's text and the button never returns to "Add to Cart". */
  var flashTimers = new WeakMap();

  function setLabel(btn, msg, cls) {
    if (!btn) return;

    if (btn.dataset.label === undefined) {
      btn.dataset.label = btn.textContent.trim();
    }

    var pending = flashTimers.get(btn);
    if (pending) {
      clearTimeout(pending);
      flashTimers.delete(btn);
    }

    btn.classList.remove('multi-print-pdp__atc--added');
    btn.textContent = msg;
    if (cls) btn.classList.add(cls);
  }

  function restoreLabel(btn, delay) {
    if (!btn) return;
    var t = setTimeout(function () {
      btn.textContent = btn.dataset.label || 'Add to Cart';
      btn.classList.remove('multi-print-pdp__atc--added');
      delete btn.dataset.busy;
      flashTimers.delete(btn);
    }, delay);
    flashTimers.set(btn, t);
  }

  /* ---------- CART FEEDBACK, WITHOUT THE DRAWER ----------
     Adding to cart used to open the theme's full-screen cart drawer, which
     ends the browsing session. Now the shopper stays on the page: the header
     count updates, a small toast offers a way into the cart, and the free
     shipping line shows progress. */

  var FREE_SHIP = Number((section.dataset.freeShipping || '0').replace(/[^0-9.]/g, '')) || 0;

  function money(cents) {
    var v = (cents / 100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function updateCount(count) {
    var sel = [
      '[data-cart-count]', '[data-header-cart-count]', '.cart-count',
      '.cart__count', '.header__cart-count', '.cart-count-bubble span',
      '#CartCount', '.js-cart-count'
    ].join(',');
    document.querySelectorAll(sel).forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
      el.style.display = count < 1 ? 'none' : '';
    });
  }

  function updateShipping(totalCents) {
    if (!FREE_SHIP) return;
    var target = FREE_SHIP * 100;
    var left = target - totalCents;
    var pct = Math.max(0, Math.min(100, Math.round((totalCents / target) * 100)));
    var msg;
    if (totalCents <= 0) {
      // nothing in the cart yet — state the offer rather than the gap
      msg = 'Free worldwide shipping over <strong>' + money(target) + '</strong>';
    } else if (left > 0) {
      msg = 'You\u2019re <strong>' + money(left) + '</strong> from free shipping';
    } else {
      msg = '<strong>You\u2019ve unlocked free shipping</strong>';
    }

    var el = section.querySelector('.multi-print-pdp__freeship');
    if (el) {
      var bar = el.querySelector('.multi-print-pdp__freeship-fill');
      var txt = el.querySelector('.multi-print-pdp__freeship-text');
      if (bar) bar.style.width = pct + '%';
      if (txt) txt.innerHTML = msg;
      el.hidden = false;
      el.classList.toggle('is-complete', totalCents > 0 && left <= 0);
    }

  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        updateShipping(cart.total_price);
        return cart;
      })
      .catch(function () {});
  }

  // show progress on load too
  refreshCart();

  function addToCart(trigger) {
    if (!mainForm) return;
    if (trigger && trigger.dataset.busy) return;

    var id = variantInput && variantInput.value;
    if (!id) return;

    setLabel(trigger, 'Adding…', null);
    if (trigger) trigger.dataset.busy = '1';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        setLabel(trigger, 'Added ✓', 'multi-print-pdp__atc--added');
        restoreLabel(trigger, 2000);
        refreshCart();
      })
      .catch(function () {
        // network or API problem — restore the label, then let the browser
        // do it the old way
        setLabel(trigger, trigger && trigger.dataset.label ? trigger.dataset.label : 'Add to Cart', null);
        if (trigger) delete trigger.dataset.busy;
        mainForm.submit();
      });
  }

  /* Our button is type="button", so it never submits the form and the
     theme's own product-form handler never sees it. Capture phase plus
     stopImmediatePropagation means nothing else acting on this click runs. */
  if (atcButton) {
    atcButton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(atcButton);
    }, true);
  }

  // Guard against the form being submitted some other way (Enter key)
  if (mainForm) {
    mainForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(atcButton);
    }, true);
  }

  /* ---------- 5. RESTORE SIZE ON LOAD ----------
     Precedence:
       1. ?variant= in the URL  (a shared or bookmarked link)
       2. size remembered from earlier in this session
       3. whatever Liquid rendered as default
     If the remembered size does not exist on this product, or is sold out,
     nothing is selected and the shopper picks again. */

  function selectButton(btn) {
    sizeButtons.forEach(function (b) {
      b.classList.remove('multi-print-pdp__size-btn--active');
    });
    btn.classList.add('multi-print-pdp__size-btn--active');
    if (variantInput) variantInput.value = btn.dataset.variantId;
  }

  var variantParam = new URLSearchParams(window.location.search).get('variant');
  var restored = false;

  if (variantParam) {
    var byVariant = section.querySelector(
      '.multi-print-pdp__size-btn[data-variant-id="' + variantParam + '"]'
    );
    if (byVariant && !byVariant.disabled) {
      selectButton(byVariant);
      restored = true;
    }
  }

  if (!restored) {
    var savedSize = null;
    try { savedSize = sessionStorage.getItem(SIZE_KEY); } catch (e) {}

    if (savedSize) {
      var match = null;
      sizeButtons.forEach(function (b) {
        if (!match && !b.disabled && (b.textContent || '').trim() === savedSize) {
          match = b;
        }
      });
      if (match) {
        selectButton(match);
      } else {
        // this product does not carry that size — clear the selection
        sizeButtons.forEach(function (b) {
          b.classList.remove('multi-print-pdp__size-btn--active');
        });
      }
    }
  }
})();